import React from 'react';

const Footer = () => {
  return (
    <footer
      style={{
        backgroundColor: '#002366',
        color: '#ffffff',
        fontFamily: 'Times New Roman, serif',
        width: '100%',
        overflow: 'hidden',
      }}
    >
      {/* 📸 Footer Image */}
      <div style={{ width: '100%', overflow: 'hidden' }}>
        <img
          src="/footer-image.jpg" // Replace with your actual image path (e.g., /assets/footer-temple.jpg)
          alt="Temple artwork"
          style={{
            width: '100%',
            height: 'auto',
            display: 'block',
            objectFit: 'cover',
            maxHeight: '400px', // Change this if needed
          }}
        />
      </div>

      {/* 📞 Connect Section */}
      <div
        style={{
          textAlign: 'center',
          padding: '30px 20px',
        }}
      >
        <h3 style={{ fontSize: '1.1rem', marginBottom: '16px' }}>Connect With Us</h3>

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '16px',
            flexWrap: 'wrap',
            marginBottom: '20px',
          }}
        >
          <SocialLink
            href="https://youtube.com/@sthapathi_s.b.kalyanasundaram?si=T9b3J96xeKKQpU9R"
            label="YouTube"
          />
          <SocialLink
            href="https://www.instagram.com/sthapathi1?igsh=aDlnMThwdGhlZ3hu"
            label="Instagram"
          />
          <SocialLink
            href="https://www.facebook.com/share/18ZQRQvwV8/"
            label="Facebook"
          />
        </div>

        <p style={{ fontSize: '0.95rem', color: '#e0e0e0' }}>
          © {new Date().getFullYear()} Kalyanasundaram Sthapati Pvt Ltd. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

const SocialLink = ({ href, label }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    style={{
      backgroundColor: '#ffffff',
      color: '#002366',
      padding: '10px 16px',
      borderRadius: '6px',
      textDecoration: 'none',
      fontWeight: 'bold',
      fontSize: '1rem',
      transition: 'all 0.3s ease',
    }}
    onMouseOver={(e) => {
      e.target.style.backgroundColor = '#d4af37';
      e.target.style.color = '#ffffff';
    }}
    onMouseOut={(e) => {
      e.target.style.backgroundColor = '#ffffff';
      e.target.style.color = '#002366';
    }}
  >
    {label}
  </a>
);

export default Footer;





